/*
    Enumerate and Range are used to create a generic of type number that has to fit within a certain range
    Example usage: Range<0, 10> (expects a number of minimum 0 and maximum 10)
*/
type Enumerate<N extends number, Acc extends number[] = []> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>;

export type Range<F extends number, T extends number> = Exclude<Enumerate<T>, Enumerate<F>>;

/*
Alpha Codes and respective countries
GB - Great Britain | LR - Liberia | MM - Myanmar | US - United States of America
*/
export const IMPERIAL_UNIT_COUNTRIES = ['GB', 'LR', 'MM', 'US'];

export enum Symptom {
  NoSymptoms = 'no_symptoms',
  Palpitations = 'palpitations',
  ChestPain = 'chest_pains',
  ShortnessOfBreath = 'shortness_of_breath',
  RacingHeart = 'racing_heart',
  Lightheaded = 'lightheaded',
  Confused = 'confused',
  Fatigue = 'fatigue',
  Dizziness = 'dizziness',
  FeelingOfFainting = 'feeling_of_fainting',
  Anxiety = 'anxiety',
  Other = 'other',
}

export const SymptomSeverities = {
  none: '1',
  mild: '2a',
  moderate: '2b',
  severe: '3',
  disabling: '4',
};

export type SymptomSeverity = (typeof SymptomSeverities)[keyof typeof SymptomSeverities];

export const Activities = {
  sitting: 'sitting',
  standing: 'standing',
  walking: 'walking',
  exercising: 'exercising',
  sleeping: 'sleeping',
  working: 'working',
  resting: 'resting',
  other: 'other',
};

export type Activity = (typeof Activities)[keyof typeof Activities];

export enum UnitType {
  Metric = 'Metric',
  Imperial = 'Imperial',
}

export enum HeightUnit {
  Centimeters = 'cm',
  Inches = 'in',
}

export enum HeartRateUnit {
  BeatsPerMinute = 'bpm',
}

export enum BloodPressureUnit {
  MillimetersOfMercury = 'mmHg',
}

export enum WeightUnit {
  Kilograms = 'kg',
  Pounds = 'lbs',
}

export enum HourFormat {
  TwelveHour = '12-Hour',
  TwentyFourHour = '24-Hour',
}
